module.exports = __webpack_public_path__ + "static/cosypgiraffe1-a030654293a1654558701fb9e3c2bf69.jpeg";